/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { BulkJobStatusReq, BulkJobStatusResp, HTTPValidationError, JobStatusResponse } from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetJobStatusUrl = (jobId: string) => {
  return `/api/v1/async_jobs/status/${jobId}`;
};

/**
 * @summary Get Job Status
 */
export const getJobStatus = async (
  jobId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<JobStatusResponse> => {
  return customFetch<JobStatusResponse>(getGetJobStatusUrl(jobId), {
    ...options,
    method: 'GET',
  });
};

export const getGetJobStatusQueryKey = (jobId: string) => {
  return [`/api/v1/async_jobs/status/${jobId}`] as const;
};

export const getGetJobStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobStatus>>,
  TError = HTTPValidationError,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobStatusQueryKey(jobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobStatus>>> = ({ signal }) =>
    getJobStatus(jobId, { signal, ...requestOptions });

  return { queryKey, queryFn, enabled: jobId !== null && jobId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetJobStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getJobStatus>>>;
export type GetJobStatusQueryError = HTTPValidationError;

/**
 * @summary Get Job Status
 */

export function useGetJobStatus<TData = Awaited<ReturnType<typeof getJobStatus>>, TError = HTTPValidationError>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJobStatus>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobStatusQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetBulkJobStatusUrl = () => {
  return `/api/v1/async_jobs/status/bulk`;
};

/**
 * @summary Get Bulk Job Status
 */
export const getBulkJobStatus = async (
  bulkJobStatusReq: BulkJobStatusReq,
  options?: Parameters<typeof customFetch>[1],
): Promise<BulkJobStatusResp> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<BulkJobStatusResp>(getGetBulkJobStatusUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(bulkJobStatusReq),
  });
};

export const getGetBulkJobStatusMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getBulkJobStatus>>,
    TError,
    GetBulkJobStatusMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getBulkJobStatus>>,
  TError,
  GetBulkJobStatusMutationVariables,
  TContext
> => {
  const mutationKey = ['getBulkJobStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getBulkJobStatus>>,
    GetBulkJobStatusMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getBulkJobStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetBulkJobStatusMutationResult = NonNullable<Awaited<ReturnType<typeof getBulkJobStatus>>>;
export type GetBulkJobStatusMutationBody = BulkJobStatusReq;
export type GetBulkJobStatusMutationError = HTTPValidationError;
export type GetBulkJobStatusMutationVariables = { data: BulkJobStatusReq };

/**
 * @summary Get Bulk Job Status
 */
export const useGetBulkJobStatus = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getBulkJobStatus>>,
    TError,
    GetBulkJobStatusMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getBulkJobStatus>>,
  TError,
  GetBulkJobStatusMutationVariables,
  TContext
> => {
  return useMutation(getGetBulkJobStatusMutationOptions(options));
};
